import { ASSET_V, FLAVORS, PACKS, NUTRITION, STORE, SUB_PLAN, amazonUrl, byId, flavorById, isPack, money, planById, productUrl } from 'v2/catalog.js';
import { NOTES, PHOTO, SITE_NOTES, SITE_SCENES, WALL_ON, OBJECTIONS, QA } from 'v2/aplus.js';
import { planPrices } from 'v2/shopify.js';
import { $, $$, canSrc, reducedMotion, initChrome, addToCart, cart, shipMessage } from 'v2/ui.js';
import { asset } from 'v2/asset.js';

// The product comes from the generated page (<body data-product>) or, on the template, ?flavor= / ?pack=. The
// template's photos are Classic Orange's (tools/build-pages.py); in production /product redirects to /shop.
const params = new URLSearchParams(location.search);
const p = byId(document.body.dataset.product || params.get('flavor') || params.get('pack')) || FLAVORS[0];
const pack = isPack(p);

document.body.classList.add(pack ? 'f-pack' : `f-${p.id}`, pack ? 'is-pack' : 'is-flavor');
if (pack) document.body.dataset.nav = 'packs';
if (!document.body.dataset.product) {
  document.title = `${p.full || p.name} | 10g Protein, Zero Sugar | PRODA`;
  $('meta[name="description"]').content = pack ? p.desc : `${p.name} protein soda. ${p.desc} Zero sugar. $39.95 for 12 cans.`;
}

/* ---------- Buy box ---------- */
$('[data-crumb]').textContent = p.name;
const crumbParent = $('.crumbs a:nth-of-type(2)');
if (pack) { crumbParent.textContent = 'Variety packs'; crumbParent.href = '/#packs'; }
$('[data-kicker]').textContent = pack
  ? 'Variety pack · 12 cans, 3 of each'
  : `No. ${String(FLAVORS.indexOf(p) + 1).padStart(2, '0')} · ${p.tag || 'Protein soda'} · 12 fl oz cans`;
$('[data-title]').textContent = p.name;
$('[data-line]').textContent = p.line;
$('[data-desc]').textContent = pack ? `${p.desc} Each can has 10g of whey protein isolate and zero sugar.` : p.desc;
$('[data-price]').textContent = money(p.price);
$('[data-per-can]').textContent = money(p.price / 12);

let qty = 1;
const qtyOut = $('[data-qty-val]');
$$('.pdp__cta [data-step]').forEach((b) => b.addEventListener('click', () => {
  qty = Math.min(9, Math.max(1, qty + Number(b.dataset.step)));
  qtyOut.textContent = qty;
  renderBuy();
}));
// Subscribe and Save: every 2, 4 or 6 weeks (PLANS; the choices under it are baked from them by build-pages), every 2
// weeks (SUB_PLAN) preselected, each at Shopify's price from the Storefront API (never the site's own arithmetic). The
// case goes into the cart with its plan, and checkout builds a real Shopify cart, so Shopify bills and renews it
// (js/shopify.js). If Shopify can't be reached, the page falls back to one-time, and choosing to subscribe hands off to
// the live product page instead, as before. The line under the choices is the auto-renewal disclosure: what is charged,
// how often, until when, and how to cancel, next to the button (California's automatic renewal law, ROSCA).
let plan = null; // the selling plan id, or null for one-time
let prices = null; // { sellingPlanId: { price, save, was } } from Shopify; false when it can't be reached
// A shopper from a Google product listing lands on the price that listing showed, the one-time price (Merchant
// Center checks the page against it). Google & YouTube links carry ?variant= and utm_medium=product_sync, free
// listings add srsltid. On Shopify the theme already preselects one-time for ?variant=.
if (params.has('variant') || params.has('srsltid') || params.get('utm_medium') === 'product_sync') {
  $('input[name="plan"][value="once"]').checked = true;
}
$('[data-sub-link]').href = `${STORE}/products/${p.handle}`;
// "Buy it on Amazon" with this site's Amazon Attribution tag (build-pages bakes the same link into each product page).
const amazonLine = $('[data-amazon]');
if (amazonLine && amazonUrl(p)) {
  const link = amazonLine.querySelector('[data-amazon-link]');
  link.href = amazonUrl(p);
  link.dataset.amazonAsin = p.asin;
  amazonLine.hidden = false;
}
// On Shopify the page carries Shopify's plan prices (window.PRODA_LIVE), so Subscribe is ready at once; elsewhere
// they come from the Storefront API.
const livePlans = p.plans && Object.fromEntries(Object.entries(p.plans).filter(([, v]) => v?.price && v?.was)
  .map(([num, v]) => [`gid://shopify/SellingPlan/${num}`, { price: v.price, save: v.was - v.price, was: v.was }]));
const off = (s) => `Save ${Math.round((s.save / s.was) * 100)}%`; // the saving as Shopify prices it
const every = () => planById($('input[name="every"]:checked')?.value) || SUB_PLAN;
// A product without Subscribe and Save (catalog sub: false, Cranberry Cheer) sells one-time only: build-pages bakes the
// page that way, and nothing asks Shopify for plan prices.
const noSub = p.sub === false;
if (noSub) { $('.opt--sub').hidden = true; $('input[name="plan"][value="once"]').checked = true; }
(noSub ? Promise.resolve({}) : livePlans?.[SUB_PLAN.id] ? Promise.resolve(livePlans) : planPrices(p.variant)).then((got) => {
  if (noSub) return;
  if (!got[SUB_PLAN.id]) throw new Error('missing plan price');
  prices = got;
  // Each choice shows Shopify's saving; a plan Shopify doesn't offer on this product comes off the page.
  $$('input[name="every"]').forEach((r) => {
    const s = got[r.value];
    r.closest('.freq__opt').hidden = !s;
    if (s) $('[data-plan-off]', r.closest('.freq__opt')).textContent = off(s);
  });
  const fallback = $(`input[name="every"][value="${SUB_PLAN.id}"]`);
  if (!got[every().id] && fallback) fallback.checked = true;
}).catch(() => {
  prices = false;
  $('input[name="plan"][value="once"]').checked = true;
}).finally(renderBuy);
function renderBuy() {
  const sub = $('input[name="plan"][value="sub"]').checked;
  const handOff = sub && prices === false; // Shopify unreachable: subscribe on drinkproda.com
  const choice = every();
  const s = prices?.[choice.id];
  plan = sub && !handOff ? choice.id : null;
  const unit = plan ? s?.price : p.price;
  if (s) {
    const put = (sel, text) => { const el = $(sel); if (el) el.textContent = text; };
    put('[data-sub-price]', money(s.price));
    put('[data-sub-was]', money(s.was));
    put('[data-sub-flag]', off(s));
    put('[data-sub-note]', `Delivered every ${choice.weeks} weeks · ${money(s.price / 12)} per can · Save ${money(s.save)} a case`);
    put('[data-sub-terms]', `Renews automatically: ${money(s.price * qty)} every ${choice.weeks} weeks${qty > 1 ? ` for ${qty} cases` : ''}, plus tax and any shipping, until you cancel.`);
  }
  $('[data-sub-fine]').hidden = !sub;
  $('[data-sub-link]').hidden = !handOff;
  $$('[data-pdp-add]').forEach((b) => {
    const verb = plan ? 'Subscribe' : 'Add to cart';
    b.hidden = handOff;
    b.disabled = Boolean(plan) && !prices; // wait for Shopify's plan price
    // The main button says what the click costs; the sticky bar's button stays short.
    b.textContent = b.matches('[data-pdp-main]') && unit ? `${verb} · ${money(unit * qty)}` : verb;
  });
  $('[data-buybar-price]').textContent = plan && s ? `${money(s.price)} · every ${choice.weeks} weeks` : `${money(p.price)} · 12 cans`;
  renderShip();
}
$$('input[name="plan"]').forEach((r) => r.addEventListener('change', renderBuy));
// Picking how often also picks Subscribe and save (click too: the choice may already be checked under one-time).
const pickEvery = () => { $('input[name="plan"][value="sub"]').checked = true; renderBuy(); };
$$('input[name="every"]').forEach((r) => { r.addEventListener('change', pickEvery); r.addEventListener('click', pickEvery); });
$$('[data-pdp-add]').forEach((b) => b.addEventListener('click', () => addToCart(p.id, qty, { ...(plan ? { plan, price: prices[plan].price, was: prices[plan].was } : {}), from: b })));

function renderShip() {
  const m = shipMessage(cart.cases() + qty);
  $('[data-pdp-ship]').innerHTML = cart.cases() >= 2
    ? 'Your cart already ships <b>free</b>.'
    : m.free ? `With ${qty} ${qty === 1 ? 'case' : 'cases'} here, <b>shipping is free</b>.` : '<b>Free shipping</b> on 2+ cases. Mix any flavors.';
}
cart.onChange(renderShip);

$('[data-swatches]').innerHTML = FLAVORS.map((x) => `
  <a class="swatch f-${x.id}${x.id === p.id ? ' is-current' : ''}" href="${productUrl(x.id)}" ${x.id === p.id ? 'aria-current="page"' : ''}>
    <i><img src="${canSrc(x.id, 'sm')}" alt="" width="186" height="360" loading="lazy"></i><span>${x.name}</span>
  </a>`).join('');
$('[data-pack-links]').innerHTML = PACKS.map((x) => `
  <a class="pack-link${x.id === p.id ? ' is-current' : ''}" href="${productUrl(x.id)}" ${x.id === p.id ? 'aria-current="page"' : ''}>
    <span class="pack-link__dots">${x.flavors.map((id) => `<i class="f-${id}"></i>`).join('')}</span>${x.name} pack
  </a>`).join('');

/* ---------- Photos: the stage is a row of slides that snaps one photo at a time (swipe, arrows, thumbnails) ---------- */
// The slides and thumbnails are baked into the page by tools/build-pages.py; only the first photo loads with the
// page, and each move loads the next two ahead.
const track = $('[data-slides]');
const slides = $$('.pdp__slide', track);
const thumbs = $$('[data-thumb]');
const [prevBtn, nextBtn] = $$('[data-slide-step]');
const thumbRow = $('[data-thumbs]');
$('[data-slide-total]').textContent = slides.length;
let at = 0;
let jumpTo = null; // the slide a thumbnail or arrow is scrolling to; the scroll events on the way don't count
let jumpTimer = 0;
const warm = (i) => { const im = slides[i] && $('img', slides[i]); if (im?.loading === 'lazy') im.loading = 'eager'; };
function mark(i) {
  at = i;
  thumbs.forEach((t, j) => { t.setAttribute('aria-selected', String(j === i)); t.tabIndex = j === i ? 0 : -1; });
  $('[data-slide-at]').textContent = i + 1;
  prevBtn.disabled = i === 0;
  nextBtn.disabled = i === slides.length - 1;
  warm(i + 1); warm(i + 2);
  // Keep the picked thumbnail in view inside its row (never scrolls the page).
  const t = thumbs[i];
  if (t && thumbRow.scrollWidth > thumbRow.clientWidth) {
    thumbRow.scrollTo({ left: t.offsetLeft - (thumbRow.clientWidth - t.offsetWidth) / 2, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
}
function go(i) {
  i = Math.max(0, Math.min(slides.length - 1, i));
  warm(i);
  jumpTo = i;
  clearTimeout(jumpTimer);
  jumpTimer = setTimeout(() => { jumpTo = null; }, 1200);
  track.scrollTo({ left: i * track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
  mark(i);
}
track.addEventListener('scroll', () => {
  const i = Math.round(track.scrollLeft / track.clientWidth);
  if (jumpTo !== null) { if (i !== jumpTo || Math.abs(track.scrollLeft - i * track.clientWidth) > 2) return; jumpTo = null; }
  if (i !== at) mark(i);
}, { passive: true });
prevBtn.addEventListener('click', () => go(at - 1));
nextBtn.addEventListener('click', () => go(at + 1));
thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
// The thumbnails are a tablist: the arrow keys move between them and the stage follows; Home and End jump.
thumbRow.addEventListener('keydown', (e) => {
  const k = { ArrowRight: at + 1, ArrowLeft: at - 1, Home: 0, End: slides.length - 1 }[e.key];
  if (k === undefined) return;
  e.preventDefault();
  go(k);
  thumbs[at].focus();
});
// A resize changes the slide width: stay on the same photo.
new ResizeObserver(() => { track.scrollLeft = at * track.clientWidth; }).observe(track);
addEventListener('load', () => warm(1), { once: true });

/* ---------- What's inside (packs) ---------- */
if (pack) {
  $('[data-inside]').hidden = false;
  $('[data-inside-grid]').innerHTML = p.flavors.map((id) => {
    const x = flavorById(id);
    return `<a class="inside__item f-${id}" href="${productUrl(id)}">
      <img src="${canSrc(id, 'md')}" alt="" width="310" height="600" loading="lazy">
      <span class="inside__count"><span aria-hidden="true">×3</span><span class="visually-hidden">3 cans of</span></span>
      <span class="inside__label"><span class="inside__name">${x.name}</span><span class="inside__cta" aria-hidden="true">See the flavor →</span></span>
    </a>`;
  }).join('');
}

/* ---------- Nutrition (from the live product description) ---------- */
// A product with its own facts (Cranberry Cheer: only the numbers the team gave) shows those and sends shoppers to the
// can for the rest, with no ingredient statement until one is on file for it.
$('[data-facts]').innerHTML = p.facts ? `
  <div class="facts__card">
    <p class="facts__head">Nutrition <span>per 12 fl oz can</span></p>
    <dl>${p.facts.map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}</dl>
    <p class="facts__src">See the can for the full Nutrition Facts panel and ingredients.</p>
  </div>` : `
  <div class="facts__card">
    <p class="facts__head">Nutrition <span>per 12 fl oz can</span></p>
    <dl>${NUTRITION.facts.map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}</dl>
    <p class="facts__ing"><b>Ingredients:</b> ${NUTRITION.ingredients}</p>
    <p class="facts__ing"><b>Contains:</b> ${NUTRITION.contains}.</p>
    <p class="facts__src">As listed on drinkproda.com. See the can for the full label.</p>
  </div>`;

/* ---------- Up close: the pour film, or the fruit still ---------- */
// Andrew (2026-10-08): "videos of just the fizz colors ... a close up of a glass and as its poured in you see the
// bubbles in motion, and then it freezes on the last". Each film plays once when it comes into view and stays on its last
// frame, the full glass. Its posters are the first frame (before it plays) and the last (reduced motion). Built by
// tools/build-assets.sh pour from ~/PRODA/creative/lifestyle-shoot-2026-10-08/out/pour.
const POURS = new Set(['classic-orange', 'cherry-lime', 'strawberry-lemonade', 'lemon-lime', 'golden-apple', 'root-beer', 'shirley-temple']);
const filmBand = $('[data-film-band]');
const band = $('[data-film-poster]');
$('[data-film-title-inline]').textContent = p.name;
if (!pack && POURS.has(p.id)) {
  const pour = (f) => asset(`film/pour-${p.id}${f}?v=${ASSET_V}`);
  band.src = pour(reducedMotion ? '-end.webp' : '-start.webp');
  band.alt = '';
  filmBand.classList.add('has-pour');
  const again = $('[data-pour-again]');
  const video = document.createElement('video');
  video.className = 'pdp-film__video';
  video.muted = true;
  video.playsInline = true;
  video.preload = 'none';
  video.setAttribute('aria-hidden', 'true');
  video.poster = band.src;
  band.after(video);
  const load = () => {
    if (video.src) return;
    video.src = pour(matchMedia('(max-width: 999px)').matches ? '-540.mp4' : '.mp4');
  };
  const play = () => { load(); video.play().catch(() => {}); };
  video.addEventListener('playing', () => filmBand.classList.add('is-playing'));
  video.addEventListener('ended', () => { again.hidden = false; });
  again.addEventListener('click', () => { again.hidden = true; video.currentTime = 0; play(); });
  if (reducedMotion) {
    again.hidden = false; // the full glass shows; the button plays the pour on request
    again.lastChild.textContent = 'Play the pour';
  } else if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !video.ended) play();
      else if (!e.isIntersecting && !video.paused) video.pause();
    }, { threshold: 0.5 }).observe(filmBand);
  }
} else if (p.video) {
  // Cranberry Cheer: no pour film, and its campaign film already plays under the stage, so no "Up close" band.
  filmBand.closest('.pdp-film').hidden = true;
} else {
  const fruitId = pack ? 'medley' : p.id;
  band.srcset = `${asset(`fruit/${fruitId}-900.webp`)}?v=${ASSET_V} 900w, ${asset(`fruit/${fruitId}-1600.webp`)}?v=${ASSET_V} 1600w, ${asset(`fruit/${fruitId}-2400.webp`)}?v=${ASSET_V} 2400w`;
  band.sizes = '(max-width: 1440px) 94vw, 1440px';
  band.src = `${asset(`fruit/${fruitId}-1600.webp`)}?v=${ASSET_V}`;
}

/* ---------- A+ content: the same words as the Amazon A+ pages (js/aplus.js), with the site's own photos ---------- */
const life = (name, size) => asset(`img/life/${name}-${size}.webp?v=${ASSET_V}`);
if (!pack) {
  const n = NOTES[p.id];
  const shot = SITE_NOTES[p.id];
  const notesImg = $('[data-notes-img]');
  notesImg.srcset = `${life(shot, 600)} 600w, ${life(shot, 1200)} 1200w`;
  notesImg.sizes = '(max-width: 999px) 88vw, 38vw';
  if (PHOTO[shot].square) { notesImg.width = 1200; notesImg.height = 1200; notesImg.closest('.notes__photo').classList.add('notes__photo--square'); }
  notesImg.src = life(shot, 1200);
  notesImg.alt = PHOTO[shot].alt;
  notesImg.style.objectPosition = PHOTO[shot].pos;
  $('[data-notes-kicker]').textContent = `Tasting notes · ${p.name}`;
  $('[data-notes-head]').textContent = n.head;
  $('[data-notes-chips]').innerHTML = n.chips.map((c) => `<span class="chip chip--flavor">${c}</span>`).join('');
  $('[data-notes]').hidden = false;
}
$('[data-nomore]').innerHTML = OBJECTIONS(pack).map(([nope, yes, proof], i) => `
  <li class="nomore__row" style="--d:${i * 180}ms"><span class="nomore__nope">${nope}</span><span><span class="nomore__yes">${yes}</span><span class="nomore__proof">${proof}</span></span></li>`).join('');
if (pack) $('[data-nomore-pill]').hidden = true;
else {
  const can = $('[data-nomore-can]');
  can.srcset = `${canSrc(p.id, 'md')} 310w, ${canSrc(p.id)} 516w`;
  can.sizes = '(max-width: 999px) 40vw, 16vw';
  can.src = canSrc(p.id);
}
// Each "No more" gets struck through as the list comes into view (the story page's move).
const nomore = $('[data-nomore-section]');
if (reducedMotion || !('IntersectionObserver' in window)) nomore.classList.add('is-in');
else {
  const nio = new IntersectionObserver(([e]) => { if (e.isIntersecting) { nomore.classList.add('is-in'); nio.disconnect(); } }, { threshold: 0.35 });
  nio.observe(nomore);
}
$('[data-faq]').innerHTML = QA(pack ? p : null, { site: true }).map(([q, a]) => `
  <details class="faq__item"><summary>${q}</summary><p>${a}</p></details>`).join('');

/* ---------- Where it goes: a wall of photos, real ones first (SITE_SCENES in js/aplus.js) ---------- */
// Six or more: bands of [big, wide], [four small], [wide, big], [four small]. Two: [big, wide] (a 4:5 photo, then a
// 16:9 one). Three or four: one row. Wides are the 16:9 photos, the rest 4:5. None: the section stays hidden.
const wallNames = WALL_ON ? SITE_SCENES[p.id] || [] : [];
const SCENE_KINDS = wallNames.length >= 6
  ? ['big', 'wide', 'small', 'small', 'small', 'small', 'wide', 'big', 'small', 'small', 'small', 'small']
  : wallNames.length === 2 ? ['big', 'wide']
    : wallNames.map(() => (wallNames.length === 3 ? 'third' : 'small'));
$('[data-scenes-section]').hidden = !wallNames.length;
const SIZES = { big: '(max-width: 999px) 92vw, 31vw', wide: '(max-width: 999px) 92vw, 62vw', pair: '(max-width: 999px) 92vw, 47vw', small: '(max-width: 999px) 46vw, 23vw', third: '(max-width: 999px) 46vw, 31vw' };
const scenes = wallNames.map((name, i) => {
  const ph = PHOTO[name];
  const [lo, hi] = ph.wide ? [900, 1800] : [600, 1200];
  return { name, ph, kind: SCENE_KINDS[i] || 'small', lo, hi, w: hi, h: ph.wide ? Math.round((hi * 9) / 16) : (hi * 5) / 4, src: life(name, hi), alt: ph.alt };
});
$('[data-scenes]').innerHTML = scenes.map((s, i) => `
  <li class="scene scene--${s.kind}" data-reveal style="--d:${(i % 6) * 60}ms"><button class="scene__open" type="button" data-scene="${i}"><img srcset="${life(s.name, s.lo)} ${s.lo}w, ${life(s.name, s.hi)} ${s.hi}w" sizes="${SIZES[s.kind]}" src="${life(s.name, s.lo)}" alt="${s.alt}" style="object-position:${s.ph.pos}" width="${s.w}" height="${s.h}" loading="lazy" decoding="async"></button></li>`).join('');

/* ---------- Lightbox: a product photo or a mosaic photo opens large; arrows and the keyboard step through its set ---------- */
const lightbox = $('[data-lightbox]');
const lightImg = $('[data-lightbox-img]', lightbox);
const photos = slides.map((li) => { const im = $('img', li); return { src: im.dataset.full, alt: im.alt }; });
let shown = photos;
let lightAt = 0;
const showLight = (i) => {
  lightAt = (i + shown.length) % shown.length;
  lightImg.src = shown[lightAt].src;
  lightImg.alt = shown[lightAt].alt;
};
const openLight = (set, i) => {
  shown = set;
  $$('[data-lightbox-step]', lightbox).forEach((b) => { b.hidden = set.length < 2; });
  showLight(i);
  lightbox.showModal();
};
track.addEventListener('click', (e) => { const b = e.target.closest('[data-zoom-slide]'); if (b) openLight(photos, Number(b.dataset.zoomSlide)); });
$('[data-scenes]').addEventListener('click', (e) => { const b = e.target.closest('[data-scene]'); if (b) openLight(scenes, Number(b.dataset.scene)); });
lightbox.addEventListener('click', (e) => { const b = e.target.closest('[data-lightbox-step]'); if (b) showLight(lightAt + Number(b.dataset.lightboxStep)); });
lightbox.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowRight') showLight(lightAt + 1);
  if (e.key === 'ArrowLeft') showLight(lightAt - 1);
});
// Closing on a product photo leaves the stage on that photo.
lightbox.addEventListener('close', () => { if (shown === photos && lightAt !== at) go(lightAt); });

/* ---------- More ---------- */
const packStyle = (x) => x.flavors.map((id, i) => `--c${i + 1}:${flavorById(id).field}`).join(';');
$('[data-more]').innerHTML = [
  ...FLAVORS.filter((x) => x.id !== p.id).map((x) => `
    <article class="mini f-${x.id}">
      <a class="mini__link" href="${productUrl(x.id)}">
        <img src="${canSrc(x.id, 'sm')}" alt="" width="186" height="360" loading="lazy">
        <span class="mini__name">${x.name}</span>
      </a>
      <button class="mini__add" type="button" data-add="${x.id}" aria-label="Add a case of ${x.name}">+</button>
    </article>`),
  ...PACKS.filter((x) => x.id !== p.id).map((x) => `
    <article class="mini mini--pack f-pack" style="${packStyle(x)}">
      <a class="mini__link" href="${productUrl(x.id)}">
        <span class="mini__cans">${x.flavors.map((id) => `<img src="${canSrc(id, 'sm')}" alt="" width="186" height="360" loading="lazy">`).join('')}</span>
        <span class="mini__name">${x.name}</span>
      </a>
      <button class="mini__add" type="button" data-add="${x.id}" aria-label="Add a ${x.full}">+</button>
    </article>`),
].join('');

/* ---------- Sticky buy bar (appears once the main button scrolls away) ---------- */
const buybar = $('[data-buybar]');
$('[data-buybar-can]').src = canSrc(pack ? p.flavors[0] : p.id, 'sm');
$('[data-buybar-name]').textContent = p.name;
$('[data-buybar-price]').textContent = `${money(p.price)} · 12 cans`;
renderBuy(); // a restored form (back button) may come back with the other option picked
new IntersectionObserver(([e]) => {
  const show = !e.isIntersecting && e.boundingClientRect.top < 0;
  buybar.classList.toggle('is-on', show);
  buybar.setAttribute('aria-hidden', String(!show));
  $('button', buybar).tabIndex = show ? 0 : -1;
}).observe($('.pdp__cta'));

initChrome();
